import {
  MdOutlineProductionQuantityLimits,
  MdOutlineCategory,
  MdMiscellaneousServices,
  MdConnectWithoutContact,
  MdEmojiPeople,
  MdDashboard,
  MdPayment,
  MdBook,
} from "react-icons/md";
import { TbBrandBooking } from "react-icons/tb";
import { GiTwoCoins } from "react-icons/gi";
import { BiPurchaseTag } from "react-icons/bi";
import { IoMdCloudDownload } from "react-icons/io";
export const NavData = [
  {
    title: "Dashboard",
    path: "/",
    icon: <MdDashboard className="w-6 h-6" />,
  },
  {
    title: "Brand",
    path: "/brand",
    icon: <TbBrandBooking className="w-6 h-6" />,
  },
  {
    title: "Category",
    path: "/category",
    icon: <MdOutlineCategory className="w-6 h-6" />,
  },
  {
    title: "Product",
    path: "/product",
    icon: <MdOutlineProductionQuantityLimits className="w-6 h-6" />,
  },
  {
    title: "Service",
    path: "/service",
    icon: <MdMiscellaneousServices className="w-6 h-6" />,
  },
  {
    title: "Purchase",
    path: "/purchase",
    icon: <BiPurchaseTag className="w-6 h-6" />,
  },
  // {
  //   title: "Payment",
  //   path: "/payment",
  //   icon: <MdPayment className="w-6 h-6" />,
  // },
  {
    title: "Customers",
    path: "/customers",
    icon: <MdConnectWithoutContact className="w-6 h-6" />,
  },
  // {
  //   title: "Sales",
  //   path: "/sales",
  //   icon: <GiTwoCoins className="w-6 h-6" />,
  // },
  {
    title: "Booking",
    path: "/booking",
    icon: <MdBook className="w-6 h-6" />,
  },
  {
    title: "Staff",
    path: "/staff",
    icon: <MdEmojiPeople className="w-6 h-6" />,
  },
  // {
  //   title: "Download_Reports",
  //   path: "/downloadReports",
  //   icon: <IoMdCloudDownload className="w-6 h-6" />,
  // },
];
